import { render, staticRenderFns } from "./viewHospitalSpecialty.vue?vue&type=template&id=7a92e207&scoped=true"
import script from "./viewHospitalSpecialty.vue?vue&type=script&lang=js"
export * from "./viewHospitalSpecialty.vue?vue&type=script&lang=js"
import style0 from "./viewHospitalSpecialty.vue?vue&type=style&index=0&id=7a92e207&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a92e207",
  null
  
)

export default component.exports